import { isQuestionActive } from './formQuestionShowCondition';

/** Payload de envio alinhado ao `FormValidationService` do backend. */
export function buildFormAnswerPayload(
	formQuestions: Forms.FormQuestion[],
	sourceAnswers: Record<string, string | null>,
): Record<string, string | null> {
	const answerPayload: Record<string, string | null> = {};
	for (const q of formQuestions) {
		if (!isQuestionActive(q, sourceAnswers)) {
			answerPayload[String(q.number)] = null;
			continue;
		}
		const v = sourceAnswers[String(q.number)];
		answerPayload[String(q.number)] = v != null && v !== '' ? v : null;
	}
	return answerPayload;
}
